<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 4H21H23V6V10V12V20V22H21H3H1V20V12V10V6V4H3H5V2H7V4V6H5H3V10H21V6H19H17V4V2H19V4ZM3 20H21V12H3V20ZM9 4H15V6H9V4Z" fill="currentColor"/>
</svg>
